







































































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";

import Customer from "@/types/customer/Customer";
import UserInterface from "@/types/app/IUser";
import Investment from "@/types/app/investment";

import formatMoney from "@/utils/formatMoney";
import formatDate from "@/utils/formatDate";
import NotificationInterface from "@/types/app/notifications";

const namespace = "customer";

@Component({})
export default class ModalDetail extends Vue {
  @Getter("getModalNotificationState", { namespace })
  modalNotificationState!: boolean;
  @Getter("getModalDeleteState", { namespace })
  ModalDeleteState!: boolean;
  @Getter("getCustomer", { namespace }) customer!: Customer;
  @Getter("getLoading", { namespace }) loading!: boolean;
  @Getter("getUser", { namespace: "auth" }) user!: UserInterface;

  @Getter("getInvesmentState", { namespace }) investmentState!: Investment;
  @Getter("getNotificationState", { namespace }) notification!: NotificationInterface;

  @Action("setLoading", { namespace }) setLoading!: any;
  @Action("setModalNotificationState", { namespace })
  setModalNotificationState!: any;
  @Action("setModalDeleteState", { namespace }) setModalDeleteState!: any;
  @Action("setModalRefuseState", { namespace }) setModalRefuseState!: any;
  @Action("setModalMessageState", { namespace }) setModalMessageState!: any;
  @Action("removeCustomerFromList", { namespace }) removeCustomerFromList!: any;

  message = String();
  formatDate = formatDate;
  formatMoney = formatMoney;

  openExternalLink(link: string): void {
    window.open(link, "_blank");
  }

  showRefusement(): void {
    this.setModalRefuseState(true);
  }

  showConfirmDelete(): void {
    this.setModalNotificationState(false);
    this.setModalDeleteState(true);
  }

  closeModal(): void {
    this.setModalNotificationState(false);
  }
}
